/* The cart, inside the slide out panel.

   WHY IT IS THE SAME PANEL AND NOT A SECOND DRAWER. The store already has one
   thing that slides in from the right, with one open and close animation, one
   scroll lock and one set of focus rules. A second drawer would be a second of
   each, and the two would drift. The panel gains a mode instead: .is-cart
   hides the navigation and shows the basket, and a Menu link goes back.

   THE LINKS STILL POINT AT /cart AND THAT IS DELIBERATE. The markup is a
   plain anchor to the cart page and this file cancels the navigation. With
   JavaScript off, or before this file has parsed, clicking the cart does what
   it has always done. Nothing here is load bearing for buying.

   THE MODAL'S CART BUTTON IS CAUGHT IN THE CAPTURE PHASE AND THAT IS THE ONLY
   WAY. The app extension binds its own click handler to that button, which
   closes the modal on the way to the cart page. A listener on document in the
   ordinary bubble phase runs AFTER the button's own, so the modal was already
   shut by the time the drawer opened and the customer lost the parts finder
   they were standing in. Capturing and stopping propagation gets there first.

   PRICES ARE NOT FORMATTED BY HAND. /cart.js returns integers in the shop's
   minor unit and the currency code comes off the markup, so Intl does the
   work.

   ---------------------------------------------------------------------------
   29 Sep 2026. A REPORTED BUG: ADDING QUANTITY EMPTIED THE CART.

   Reproduced and measured. /cart/change.js answers a request it does not like
   with a plain error object and an HTTP 400:

     {"status":"bad_request","message":"no valid id or line parameter", ...}

   render() was handed that object and asked itself one question, whether it
   had any items. It did not, so it printed "Your cart is empty." and set the
   header count to zero. The server still held the line. A customer who saw
   that had every reason to think their basket had been thrown away.

   Three changes came out of it, and the first is the one that matters:

   1. RENDER ONLY EVER DRAWS A REAL CART. Anything that is not one is a failed
      request, not an empty basket, and the answer to a failed request is to
      ask again, never to wipe what is on screen. A cart is an object with a
      numeric item_count and an items array; nothing else qualifies.

   2. THE LINE IS ADDRESSED BY INDEX, NOT BY KEY. A line key carries a hash
      that changes when the line does, so a key read at render time can be
      stale by the time it is used. The 1-based index is derived from the same
      response this list was drawn from and cannot drift from it.

   3. MINUS STOPS AT ONE. It used to send quantity 0 from a quantity of 1,
      which removes the line. Two adjacent controls where one silently deletes
      is a trap on a phone, and Remove is right there and says what it does.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* No guard here before, so a second include bound a second set of handlers. */
  if (window.fxCartOn) return;
  window.fxCartOn = 1;

  var panel, root, body, foot, total;
  var currency = 'USD';
  var busy = false;

  function isCart(c) {
    return !!c && typeof c === 'object' &&
      typeof c.item_count === 'number' &&
      Object.prototype.toString.call(c.items) === '[object Array]';
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  /* ------------------------------------------------------------ render -- */
  function line(item, index) {
    var row = el('div', 'fx-cart__item');
    row.setAttribute('data-key', item.key);
    row.setAttribute('data-line', String(index + 1));

    var fig = document.createElement('a');
    fig.className = 'fx-cart__img';
    fig.href = item.url || '#';
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
      img.alt = '';
      img.loading = 'lazy';
      fig.appendChild(img);
    }
    row.appendChild(fig);

    var info = el('div', 'fx-cart__info');
    var name = document.createElement('a');
    name.className = 'fx-cart__name';
    name.href = item.url || '#';
    name.textContent = item.product_title || item.title || '';
    info.appendChild(name);

    var variant = item.variant_title;
    if (variant && variant !== 'Default Title') {
      info.appendChild(el('p', 'fx-cart__variant', variant));
    }

    var qty = el('div', 'fx-cart__qty');

    var less = el('button', 'fx-cart__step', '−');
    less.type = 'button';
    less.setAttribute('aria-label', 'Reduce quantity');
    if (item.quantity > 1) {
      less.setAttribute('data-fx-qty', String(item.quantity - 1));
    } else {
      /* One is the floor. Removing is what Remove is for. */
      less.disabled = true;
      less.setAttribute('aria-disabled', 'true');
    }

    var count = el('span', 'fx-cart__count', String(item.quantity));
    var more = el('button', 'fx-cart__step', '+');
    more.type = 'button';
    more.setAttribute('aria-label', 'Increase quantity');
    more.setAttribute('data-fx-qty', String(item.quantity + 1));

    qty.appendChild(less);
    qty.appendChild(count);
    qty.appendChild(more);
    info.appendChild(qty);
    row.appendChild(info);

    var right = el('div', 'fx-cart__right');
    right.appendChild(el('strong', 'fx-cart__price', money(item.final_line_price)));
    var rm = el('button', 'fx-cart__rm', 'Remove');
    rm.type = 'button';
    rm.setAttribute('data-fx-qty', '0');
    right.appendChild(rm);
    row.appendChild(right);

    return row;
  }

  function render(cart) {
    if (!body) return;

    /* A failed request is not an empty cart. Leave the screen alone and go
       and ask the server what the truth is. */
    if (!isCart(cart)) { reload(true); return; }

    body.textContent = '';

    if (!cart.items.length) {
      body.appendChild(el('p', 'fx-cart__empty', 'Your cart is empty.'));
      if (foot) foot.hidden = true;
      badge(0);
      return;
    }

    cart.items.forEach(function (item, i) { body.appendChild(line(item, i)); });
    if (total) total.textContent = money(cart.total_price);
    if (foot) foot.hidden = false;
    badge(cart.item_count);
  }

  /* The header count is whatever the server just said it is. */
  function badge(count) {
    document.querySelectorAll('.fx-hdr .fx-icon .cart-count-bubble').forEach(function (b) {
      b.remove();
    });
    if (!count) return;
    document.querySelectorAll('.fx-hdr [data-fx-cart-open]').forEach(function (a) {
      var b = el('div', 'cart-count-bubble');
      b.appendChild(el('span', null, count < 100 ? String(count) : '99+'));
      a.appendChild(b);
    });
  }

  /* -------------------------------------------------------------- data -- */
  function fail() {
    body.textContent = '';
    var p = el('p', 'fx-cart__empty', 'We could not reach your cart just now. ');
    var a = document.createElement('a');
    a.href = '/cart';
    a.textContent = 'Open the cart page';
    p.appendChild(a);
    body.appendChild(p);
  }

  /* quiet is true when this is a recovery from a rejected change: the list on
     screen is still the best thing the customer has, so it stays until a real
     cart arrives to replace it. */
  function reload(quiet) {
    if (!body) return;
    if (!quiet) {
      body.textContent = '';
      body.appendChild(el('p', 'fx-cart__loading', 'Loading your cart'));
    }
    window.fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (isCart(c)) render(c); else fail(); })
      .catch(fail);
  }

  function load() { reload(false); }

  function change(row, quantity) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');

    /* Index first, key only as a fallback for a row drawn before this change. */
    var payload = { quantity: quantity };
    var idx = parseInt(row.getAttribute('data-line'), 10);
    if (idx > 0) payload.line = idx;
    else payload.id = row.getAttribute('data-key');

    window.fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(render)
      .catch(function () { reload(true); })
      .then(function () {
        busy = false;
        root.classList.remove('is-busy');
        document.dispatchEvent(new CustomEvent('fx:cart-changed'));
      });
  }

  /* ------------------------------------------------------- open, close -- */
  function openCart(e) {
    if (!panel || !root) return;
    if (e) e.preventDefault();
    panel.classList.add('is-cart');
    panel.classList.add('is-open');
    if (document.querySelector('.vin-modal')) panel.classList.add('fx-panel--over');
    document.body.style.overflow = 'hidden';
    panel.querySelectorAll('[data-fx-burger]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    load();
  }

  function closePanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-fx-burger]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    window.setTimeout(function () { panel.classList.remove('is-cart'); }, 320);
  }

  function toMenu() {
    if (panel) panel.classList.remove('is-cart');
  }

  function boot() {
    panel = document.querySelector('.fx-panel');
    root = document.querySelector('[data-fx-cart]');
    if (!panel || !root) return;
    body = root.querySelector('[data-fx-cart-body]');
    foot = root.querySelector('[data-fx-cart-foot]');
    total = root.querySelector('[data-fx-cart-total]');
    currency = root.getAttribute('data-fx-currency') || 'USD';

    /* Capture, so the extension's own handler never runs. See the note at the
       top: in the bubble phase the modal has already closed. */
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (t.closest('.vin-modal [data-fx-cart-open]')) {
        ev.preventDefault();
        ev.stopPropagation();
        openCart(ev);
      }
    }, true);

    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-fx-cart-open]')) { openCart(ev); return; }
      if (t.closest('[data-fx-cart-back]')) { ev.preventDefault(); toMenu(); return; }

      /* ABOVE 750px THE PANEL IS A DRAWER AND THE REST OF THE PANEL BOX IS
         THE SCRIM. The panel is inset: 0 on a phone, where every pixel of it
         is menu and a click on its padding must do nothing; on a wider screen
         fx-cart.css pins it to the right and the area left of it is dimmed
         backdrop, which has to dismiss. Same element, so the width is what
         tells the two apart. */
      if (t === panel && window.innerWidth >= 750 && panel.classList.contains('is-open')) {
        closePanel();
        return;
      }

      // The panel's own close button leaves cart mode as well, so the next
      // time the menu is opened it is the menu.
      if (t.closest('[data-fx-burger]')) {
        window.setTimeout(function () {
          if (!panel.classList.contains('is-open')) toMenu();
        }, 340);
        return;
      }

      var step = t.closest('[data-fx-qty]');
      if (step && root.contains(step)) {
        ev.preventDefault();
        if (step.disabled) return;
        var row = step.closest('.fx-cart__item');
        if (!row) return;
        change(row, parseInt(step.getAttribute('data-fx-qty'), 10));
      }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });

    document.addEventListener('fx:cart-added', load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
